// =====================================================================
//  Controller de suppression d'une stratégie OTP.
//  Route proxy : DELETE /otp-strategy/{id}.
// =====================================================================

import {ResponseApi} from "../../Model/ResponseApi.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {IOtpStrategyModel} from "../../Model/Otp/OtpStrategyModel.js";
import {OnOtpStrategyDelete} from "../../Delegates/OtpStrategyDelegate.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";

export class OtpDelete {
    public static Delete = async (model: IOtpStrategyModel): Promise<boolean> => {
        if (!model.Primarykey) return false;

        const response = await JsonFetchJson.Delete<ResponseApi<boolean>>(
            `/otp-strategy/${model.Primarykey}`,
        );

        if (!response.Data) {
            NotificationHelper.Instance.error("La stratégie n'a pas pu être supprimée");
        } else {
            OnOtpStrategyDelete.Fire(model);
        }

        return response.Data;
    };
}
